import classNames from 'classnames';
import * as React from 'react';
import styles from './SearchBox.module.css';

export interface SearchBoxProps {
    value: string;
    placeholder: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    type?: string;
    autoFocus?: boolean;
    defaultValue?: string;
    className?: string;
    searchBoxClassName?: string;
    variant?: 'default' | 'fullWidth';
    withPageWrapper?: boolean;
    onKeyDown?: (key: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchBox: React.FC<React.PropsWithChildren<SearchBoxProps>> = React.memo(props => {
    const {
        type = 'text',
        value,
        defaultValue,
        placeholder,
        onChange,
        className,
        searchBoxClassName,
        variant = 'default',
        withPageWrapper,
        children,
        onKeyDown,
        ...otherDownshiftOptions
    } = props;

    return (
        <div
            className={classNames(
                styles[`Variant--${variant}`],
                withPageWrapper && styles['Variant--withPageWrapper'],
                styles.Header,
                className
            )}
        >
            <div className={styles.HeaderInner}>
                <div className={classNames(styles.SearchBox, searchBoxClassName)}>
                    <label>
                        <span className="visuallyHidden">{placeholder}</span>
                        <input
                            {...otherDownshiftOptions}
                            type={type}
                            defaultValue={defaultValue}
                            value={value}
                            placeholder={placeholder}
                            onChange={onChange}
                            onKeyDown={onKeyDown}
                        />
                    </label>
                    {children}
                </div>
            </div>
        </div>
    );
});
